import { useState } from 'react';
import { InputError } from '@one/web-components';
import { ACCEPT_ANY_PATTERN, Input } from 'commons/components';
import { ExtendedValidationMessages } from 'commons/components/form-elements/assistive-text';
import type { PocInputValidity } from 'commons/types';
import { useTranslation } from 'core/i18n/i18n';
import { CUSTOM_NOTIFICATION_NAME_MAX_LENGTH } from 'modules/settings/components/custom-notifications/custom-notification-form.constants';
import { resolveNameSectionValidity } from 'modules/settings/components/custom-notifications/custom-notification-form.validation';
import { CustomValidationCode } from 'core/utils/backend-service';
import {
    FormSection,
    FormSectionTitle,
} from 'modules/settings/components/custom-notifications/custom-notification-form.style';

export interface CustomNotificationNameSectionProps {
    name: string;
    labelKey: string;
    placeholderKey: string;
    inputName: string;
    autofocus?: boolean;
    validity?: PocInputValidity;
    validationMessages?: ExtendedValidationMessages;
    customValidationCode?: CustomValidationCode | InputError;
    onChange: (value: string) => void;
}

export const CustomNotificationNameSection: React.FC<CustomNotificationNameSectionProps> = ({
    name,
    labelKey,
    placeholderKey,
    inputName,
    autofocus = false,
    validity,
    validationMessages,
    customValidationCode,
    onChange,
}) => {
    const { t } = useTranslation();
    const [inputValidity, setInputValidity] = useState<PocInputValidity>();

    return (
        <FormSection>
            <FormSectionTitle variant="subtitle2">{t(labelKey)}</FormSectionTitle>
            <Input
                name={inputName}
                ariaLabel={t(labelKey)}
                placeholder={t(placeholderKey)}
                value={name}
                required
                noClearIcon={false}
                floatingAssistiveText
                maxlength={CUSTOM_NOTIFICATION_NAME_MAX_LENGTH}
                pattern={ACCEPT_ANY_PATTERN}
                autofocus={autofocus}
                validity={resolveNameSectionValidity(name, validity, inputValidity)}
                validationMessages={validationMessages}
                customValidationCode={customValidationCode}
                onChange={(_, value) => onChange(value ?? '')}
                onValidity={(_, value) => setInputValidity(value)}
            />
        </FormSection>
    );
};
